<template><div><h1>VUX V2.5.10 released</h1>
<h2><a href="/en/components/calendar.html">Calendar</a></h2>
<ul><li>[feature] Support prop:placeholder</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] support @cell-value-color #1874</li>
</ul>
<h2><a href="/en/components/marquee.html">Marquee</a></h2>
<ul><li>[feature] Support prop:item-height #1885</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] support @cell-value-color #1874</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] support @cell-value-color #1874</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] Fix class helper typo issue #1893</li>
</ul>
<h2><a href="/en/components/previewer.html">Previewer</a></h2>
<ul><li>[enhance] Support method:goTo  #1888</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.10 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.10-121.vue?658708e1